import { render, staticRenderFns } from "./EK-table-collapse.vue?vue&type=template&id=009a51d4&"
import script from "./EK-table-collapse.vue?vue&type=script&lang=js&"
export * from "./EK-table-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports